<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div style="margin-bottom: 24px;">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="优惠券搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入优惠券名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 40px;" @click="addBtn()">添加优惠券</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="couponName"
            label="优惠券名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stockNum"
            label="优惠券库存">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 添加优惠券弹窗 -->
    <el-dialog
      title="添加优惠券"
      :visible.sync="addShow"
      width="960px">
      <el-form :model="addForm" ref="addForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="优惠券：" prop="couponId">
          <el-select v-model="addForm.couponId" placeholder="请选择" class="mt-search-width" style="width: 424px;">
            <el-option
              v-for="item in couponIdArr"
              :key="item.id"
              :label="item.couponName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input class="mt-search-width" v-model="addForm.sort" placeholder="请输入排序（默认 1 ）" style="width: 424px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryCouponManagementCenterPageList, removeCouponManagementCenterById, saveCouponManagementCenter, queryAllValidCouponList } from '@/api/coupon'
export default {
  name: 'CouponCenterManage',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 添加优惠券弹窗
      addShow:false,
      couponIdArr:[],
      addForm:{
        couponId:'',
        sort:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      let dataId = this.dataId;
      queryCouponManagementCenterPageList({ couponActivityCenterId:dataId,couponName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 添加优惠券弹窗-打开操作
    addBtn(){
      let that = this
      queryAllValidCouponList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.couponIdArr = data
          that.addShow = true
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    // 添加优惠券弹窗-保存操作
    saveBtn(){
      var dataId = this.dataId;
      var couponId = this.addForm.couponId;
      var sort = this.addForm.sort === '' ? 1 : this.addForm.sort
      if(couponId == ''){
        this.$message.error('请选择优惠券');
        return false;
      }
      let that = this
      saveCouponManagementCenter({couponActivityCenterId:dataId,couponId:couponId,sort:sort}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.addForm = {
                couponId:'',
                sort:''
              }
              that.addShow = false
              that.getInfoList();
            }
          });
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeCouponManagementCenterById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/coupon/CouponCenterManage.vue